import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router } from '@angular/router';

import { BlogService } from './blog.service';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

	public data: any;
	public data2: any;
	public news_video: any[] = [];

    constructor(
		private content: BlogService,
		public router: Router
	) {
		
		this.content.getData().subscribe((data: any) => {
            this.data = data.data;
        });
		
		this.content.getData().subscribe((data2: any) => {
            this.data2 = data2;
        });

		this.content.getNewsPlaylistVideos().subscribe((res: any) => {
			this.news_video = res;
		});
		  
	}

    ngOnInit(): void {	

	}

	blogSlides: OwlOptions = {
		nav: true,
		loop: false,
		margin: 20,
		dots: true,
		autoplay: false,
		smartSpeed: 500,
		autoplayHoverPause: true,
		navText: [
			"<i class='ri-arrow-left-s-line'></i>",
			"<i class='ri-arrow-right-s-line'></i>"
		],
		responsive: {
		  0: {
			items: 1
		  },
		  576: {
			items: 1
		  },
		  768: {
			items: 2
		  },
		  1200: {
			items: 3
		  }
		}
	};
	  

}